import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PrestazioneService {

  private apiURL = environment.apiBaseUrl + '/prestazioni';

  constructor(private http: HttpClient) { }

  /*
  *  Recupera tutte le prestazioni dal server
  */
  index() {
    return this.http
      .get<{ message: string; prestazioni: any }>(
        `${this.apiURL}/get-active-prestazioni-admin`
      );
  }

  /*
  *  Recupera una prestazione dal server sapendo l'id
  */
  show(id: string | null) {
    const timestamp = new Date().getTime();

    return this.http
      .get<{ message: string; prestazione: any }>(
        `${this.apiURL}/${id}?timestamp=${timestamp}`
      );
  }

  toggleChangePotenza(id: string): Observable<any> {
    const url = `${this.apiURL}/${id}/toggleChangePotenza`;
    return this.http.post(url, {});
  }

  addBlockedSlots(id: string | null, blockedSlots: any[]): Observable<any> {
    const url = `${this.apiURL}/${id}/add-blocked-slots`;
    return this.http.post(url, { blockedSlots });
  }

  removeBlockedSlots(id: string | null, blockedSlots: any[]): Observable<any> {
    const url = `${this.apiURL}/${id}/remove-blocked-slots`;
    return this.http.post(url, { blockedSlots });
  }

  blockPeriodoPrestazione(id: string | null, dataInizio: string, dataFine: string): Observable<any> {
    const url = `${this.apiURL}/block-all-slots-prestazione`;
    return this.http.post(url, { prestazione: id, dataInizio: dataInizio, dataFine: dataFine });
  }

  blockPeriodo(dataInizio: string, dataFine: string): Observable<any> {
    const url = `${this.apiURL}/block-all-slots`;
    return this.http.post(url, { dataInizio: dataInizio, dataFine: dataFine });
  }

}
